// 공통 에러 처리 유틸리티

export interface ApiError {
  message: string;
  statusCode?: number;
  errorCode?: string;
}

export class ErrorHandler {
  static handleApiError(error: any): ApiError {
    // Axios 에러 처리
    if (error.response) {
      const { status, data } = error.response;
      return {
        message: data?.message || '서버 오류가 발생했습니다.',
        statusCode: status,
        errorCode: data?.errorCode || 'API_ERROR',
      };
    }
    
    // 네트워크 에러
    if (error.request) {
      return {
        message: '네트워크 연결을 확인해주세요.',
        statusCode: 0,
        errorCode: 'NETWORK_ERROR',
      };
    }
    
    // 기타 에러
    return {
      message: error.message || '알 수 없는 오류가 발생했습니다.',
      statusCode: 500,
      errorCode: 'UNKNOWN_ERROR',
    };
  }

  static handleStorageError(error: any, operation: string): void {
    console.warn(`Storage ${operation} failed:`, error);
  }

  static isTokenExpiredError(error: any): boolean {
    return error.response?.status === 401 || 
           error.response?.data?.errorCode === 'TOKEN_EXPIRED';
  }

  static isNetworkError(error: any): boolean {
    return !error.response && error.request;
  }

  static getErrorMessage(error: any): string {
    const apiError = this.handleApiError(error);
    return apiError.message;
  }

  static handleClientError(error: any): Error {
    const apiError = this.handleApiError(error);
    return new Error(apiError.message);
  }
}
